export default __webpack_public_path__ + "static/media/step5.fddb53b1.svg";